import { Grid, makeStyles } from '@material-ui/core';
import typesComponents from "./field-types/typesComponents";


const useStyles = makeStyles((theme) => ({
  gridFields: {
    paddingBottom: '16px',
  },
  checkboxGridField: {
    [theme.breakpoints.up('md')]: {
      paddingLeft: '16px',
    },
    paddingBottom: '16px',
  },
}));

const LpcoDynamicFields = ({
  metadado, 
  isConsult, 
  disabled, 
  basePath="", 
  ncm=false,
  ...restProps
}) => {

  const Component = typesComponents[metadado?.tipo];

  if (!Component) {
    console.error(`Tipo de campo não suportado: ${metadado?.tipo}`);
    return null;
  }

  return (
    <Component metadado={metadado} isConsult={isConsult} ncm={ncm}/>
  );
}


export default LpcoDynamicFields;